
import React from 'react';
import { Card, Typography, Box } from '@mui/material';
import { Result } from '../EmbryoGradingAi.helper';
import { useTranslation } from 'react-i18next';

export interface ResultListItemProps {
  result: Result;
  onClick?: () => void;
}

const headerSx = {
  fontFamily: 'Montserrat',
  fontWeight: 650,
  fontSize: '15px',
  lineHeight: '145%',
  letterSpacing: 0
};

const subHeaderSx = {
  fontFamily: 'Montserrat',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '145%',
  letterSpacing: 0,
  color: '#9E9E9E'
};

const ResultListItem: React.FC<ResultListItemProps> = ({
  result,
  onClick,
}) => {
  const { t: tAiGrading } = useTranslation('aiGrading_config');

  const embryoSx = {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    py: 1,
    px: 2.3,
    mb: 1,
    borderRadius: 4,
    border: result.isSelected ? '1.5px solid #F3CBC0' : '1px solid #E6E6E6',
    boxShadow: result.isSelected ? '0 2px 8px 0 #E17E6129' : 'none',
    background: result.isSelected ? '#E17E611A' : '#fff',
    cursor: 'pointer',
    transition: 'box-shadow 0.2s, border 0.2s',
    width: '100%'
  };






  return (
    <Card
      onClick={onClick}
      elevation={0}
      sx={embryoSx}
    >
      <Box sx={{ flex: 1 }}>
        <Typography sx={headerSx} mb={0.5} mt={0.5} >
          {tAiGrading('result', { defaultValue: 'Result' })} - {result.index}
        </Typography>
        <Typography sx={subHeaderSx} mb={0.5}>
          {result.retrievedAt ? (
            `${new Date(result.retrievedAt).toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' })}   |   ${new Date(result.retrievedAt).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: true })}`
          ) : ''}
        </Typography>        
      </Box>
    </Card>
  );
};

export default ResultListItem;
